import { createFileRoute } from "@tanstack/react-router"
import TabsList from "../../components/Common/TabsList"
import { Icon, Table } from "@chakra-ui/react"
import { usePermissionsFromCSV, userHasPermission } from "../../utils"
import { useMemo } from "react"
import { FiCheck } from "react-icons/fi"
import { NoPermission } from "../../components/UI/no-permission"

export const Route = createFileRoute("/_layout/permissions")({
  component: Permissions
})


function PermissionsTable() {
  // Permission check
  const [pe_read] = useMemo(() => {
    return ["read"].map(
      (action) => userHasPermission([{ perm: `permissions_${action}`, is_allowed: false }])[0].is_allowed
    )
  }, [userHasPermission])

  if(!pe_read) return <NoPermission/>

  const permissions = usePermissionsFromCSV()

  const groupedMatrix = useMemo(() => {
      const matrix: Record<string, Record<string, string>> = {}

      permissions.forEach(({ label, name }) => {
          const action = name.split("_").pop() || "unknown"
          if (!matrix[label]) matrix[label] = {}
          matrix[label][action] = name
      })

      return matrix
  }, [permissions])

  return (
    <Table.ScrollArea asChild>
      <Table.Root size={{ base: "sm", md: "md" }} stickyHeader mt={4} mb={10} whiteSpace="normal" display={{md: "table"}}>
        <Table.Header>
            <Table.Row>
                <Table.ColumnHeader>Berechtigungen</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Ansehen</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Erstellen</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Bearbeiten</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Löschen</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="center">Ausführen</Table.ColumnHeader>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {Object.entries(groupedMatrix).map(([label, actions]) => {
                return (
                  <Table.Row key={label}>
                    <Table.Cell fontWeight="bold">{label}</Table.Cell>

                    {["read", "create", "update", "delete", "execute"].map((action) => (
                        <Table.Cell key={action} textAlign="center" data-testid={`${label}_${action}`}>
                          {actions[action] &&
                            <Icon as={FiCheck} size="md" color="success">
                            </Icon>
                          }
                        </Table.Cell>
                    ))}
                  </Table.Row>
                )
            })}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  )
}

export default PermissionsTable

function Permissions() {
  const tabs = useMemo(() => [
    {value: "users", title: "Benutzer"},
    {value: "roles", title: "Rollen"},
    {value: "permissions", title: "Berechtigungen"},
  ], [])

  return (
    <TabsList tabs={tabs} defaultVal="users" />
  )
}
